<div class="experience-scope" [attr.data-theme]="theme">
  <div class="app" [attr.data-alti]="altiState">
    <aside class="rail-left">
      <div class="logo-mark" title="Cimalti">
        <img src="../../../../assets/images/logo-min-white.svg" alt="Cimalti" />
      </div>
      <a
        class="nav-ico"
        routerLink="/app/home-experience"
        title="Portfolios home"
        aria-label="Portfolios home"
      >
        <svg viewBox="0 0 24 24">
          <rect x="3" y="4" width="18" height="6" rx="2" />
          <rect x="3" y="14" width="18" height="6" rx="2" />
        </svg>
      </a>
      <div class="sep"></div>
      <button
        class="nav-ico"
        [class.active]="currentPage === 'edit'"
        [routerLink]="
          portfolioId
            ? ['/app/home-experience/portfolio', portfolioId, 'edit']
            : null
        "
        title="Edit"
        aria-label="Edit portfolio"
        type="button"
      >
        <svg viewBox="0 0 24 24">
          <path d="M4 20h16" />
          <path d="M12 4l6 6-9 9H3v-6z" />
        </svg>
      </button>
      <button
        class="nav-ico"
        [class.active]="currentPage === 'backtest'"
        [routerLink]="
          portfolioId
            ? ['/app/home-experience/portfolio', portfolioId, 'backtest']
            : null
        "
        title="Backtest"
        aria-label="Backtest"
        type="button"
      >
        <svg viewBox="0 0 24 24">
          <path d="M3 20V4" />
          <path d="M3 20h18" />
          <path d="M7 14l3-3 3 3 5-6" />
        </svg>
      </button>
      <button
        class="nav-ico"
        [class.active]="currentPage === 'optimize'"
        [routerLink]="
          portfolioId
            ? ['/app/home-experience/portfolio', portfolioId, 'optimize']
            : null
        "
        title="Optimize"
        aria-label="Optimize"
        type="button"
      >
        <svg viewBox="0 0 24 24">
          <circle cx="12" cy="12" r="8" />
          <path d="M12 4v8l5 3" />
        </svg>
      </button>
      <button
        class="nav-ico"
        [class.active]="currentPage === 'risk'"
        [routerLink]="
          portfolioId
            ? ['/app/home-experience/portfolio', portfolioId, 'risk']
            : null
        "
        title="Risk"
        aria-label="Risk"
        type="button"
      >
        <svg viewBox="0 0 24 24">
          <path d="M12 3l9 16H3z" />
          <path d="M12 10v4" />
          <circle cx="12" cy="17" r="0.6" fill="currentColor" />
        </svg>
      </button>
    </aside>

    <header class="topbar">
      @if (portfolioId) {
        <div class="crumbs">
          <a routerLink="/app/home-experience">Portfolios</a>
          <span class="chev">›</span>
          <strong>{{ portfolioName || "Loading…" }}</strong>
        </div>
      }
      @if (!portfolioId) {
        <div class="crumbs"></div>
      }
      @if (portfolioId) {
        <nav class="step-tabs">
          <button
            type="button"
            class="step-tab"
            [class.active]="currentPage === 'edit'"
            [routerLink]="[
              '/app/home-experience/portfolio',
              portfolioId,
              'edit',
            ]"
          >
            Edit Portfolio
          </button>
          <button
            type="button"
            class="step-tab"
            [class.active]="currentPage === 'backtest'"
            [routerLink]="[
              '/app/home-experience/portfolio',
              portfolioId,
              'backtest',
            ]"
          >
            Backtest
          </button>
          <button
            type="button"
            class="step-tab"
            [class.active]="currentPage === 'optimize'"
            [routerLink]="[
              '/app/home-experience/portfolio',
              portfolioId,
              'optimize',
            ]"
          >
            Optimization
          </button>
          <button
            type="button"
            class="step-tab"
            [class.active]="currentPage === 'risk'"
            [routerLink]="[
              '/app/home-experience/portfolio',
              portfolioId,
              'risk',
            ]"
          >
            Risk Analysis
          </button>
        </nav>
      }
      @if (!portfolioId) {
        <div class="step-tabs-spacer"></div>
      }
      <div class="topbar-actions">
        <button class="search-btn" type="button" (click)="openPalette()">
          <svg
            viewBox="0 0 24 24"
            width="14"
            height="14"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <circle cx="11" cy="11" r="7" />
            <path d="M16.5 16.5L21 21" />
          </svg>
          <span>Search or ask Alti</span>
        </button>
        <button
          class="icon-btn"
          type="button"
          (click)="toggleTheme()"
          [title]="theme === 'dark' ? 'Switch to light' : 'Switch to dark'"
        >
          @if (theme === "dark") {
            <svg viewBox="0 0 24 24">
              <path d="M21 13a9 9 0 11-10-10 7 7 0 0010 10z" />
            </svg>
          }
          @if (theme === "light") {
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="4" />
              <path
                d="M12 2v2M12 20v2M2 12h2M20 12h2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"
              />
            </svg>
          }
        </button>
        <button
          class="icon-btn"
          type="button"
          (click)="toggleAlti()"
          title="Toggle Alti rail"
        >
          <svg viewBox="0 0 24 24">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
            <line x1="15" y1="3" x2="15" y2="21" />
          </svg>
        </button>
        <button
          class="btn btn-ghost btn-sm exit-btn"
          type="button"
          routerLink="/app"
          title="Exit editorial view"
        >
          <svg
            viewBox="0 0 24 24"
            width="14"
            height="14"
            fill="none"
            stroke="currentColor"
            stroke-width="1.8"
          >
            <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
            <path d="M16 17l5-5-5-5" />
            <path d="M21 12H9" />
          </svg>
          <span>Exit</span>
        </button>
        <div class="avatar">Yu</div>
      </div>
    </header>

    <main class="main">
      <router-outlet></router-outlet>
    </main>

    <app-exp-alti-rail
      [page]="currentPage"
      [context]="context"
      (toggleRequest)="toggleAlti()"
    ></app-exp-alti-rail>

    <app-exp-command-palette
      [open]="paletteOpen"
      [items]="paletteItems"
      (pick)="pickPalette($event)"
      (askAlti)="palleteAskAlti($event)"
      (closed)="closePalette()"
    ></app-exp-command-palette>

    <div class="toast-wrap">
      @for (t of toasts; track t) {
        <div class="toast">
          <span class="dot"></span>
          <span>{{ t.text }}</span>
        </div>
      }
    </div>
  </div>
</div>
